import React from 'react'

import { type ColumnInfo } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { buildSequentialTableColumns, type SequentialColumnKey } from '../utils'

import { useTabulatedGroupsAndAll } from './useTabulatedGroupsAndAll'

export const useSequentialTableColumns =
  (): ColumnInfo<SequentialColumnKey>[] => {
    const groupsDiffs = useAtomValueContext('groupsDiffs')
    const tabulatedGroupsAndAll = useTabulatedGroupsAndAll()

    return React.useMemo(
      () =>
        buildSequentialTableColumns({
          groupsDiffs,
          tabulatedGroupsAndAll,
        }),
      [groupsDiffs, tabulatedGroupsAndAll],
    )
  }
